<template>
  <div class="main-bar-3">
    <div class="grid">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list"
        :key="item.id"
        class="grid__item"
      >
        <div class="card" :class="`card-${index + 1}`">
          <div class="card__img">
            <div class="card__category-img">{{ item.sub_category.name }}</div>
            <ImageContainer
              class="img"
              style="overflow: visible; boreder-radius: 0px"
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
            />
          </div>
          <div class="card__descr">
            <div class="card__category-descr">
              {{ item.sub_category.name }}
            </div>
            <div class="card__title limited-text">{{ item.title }}</div>
            <div class="data-news">
              <span class="day">{{ handleDate(item.pub_date) }},</span>
              <span class="time">{{ handleTime(item.pub_date) }}</span>
            </div>
          </div>
          <div class="card__brief">
            <div class="limited-text" style="--snup:5">
              {{ item.brief }}
            </div>
            <div class="data-news-brief">
              <span class="day">{{ handleDate(item.pub_date) }},</span>
              <span class="time">{{ handleTime(item.pub_date) }}</span>
            </div>
          </div>
        </div>
      </router-link>
      <div class="bg-dark-block"></div>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },

  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.card {
  &__brief {
    display: none;
  }
  &__img {
    overflow: hidden;
    :deep() .main-image img {
      border-radius: 0px;
      overflow: visible;
    }
  }
}
.main-bar-3 {
  width: 100%;
  padding: 80px 0;
  @media screen and (max-width: 992px) {
    padding: 15px 0;
  }
}
.grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(2, 1fr) 7vw repeat(3, 6vw);
  &__item:nth-child(1) {
    grid-column: 1 / span 5;
    grid-row: 1 / span 2;
  }
  &__item:nth-child(2) {
    grid-column: 6 / span 5;
    grid-row: 1 / span 2;
  }
  &__item:nth-child(3),
  &__item:nth-child(4),
  &__item:nth-child(5) {
    grid-column: 11 / span 2;
  }
  &__item:nth-child(3) {
    grid-row: 1 / span 2;
  }
  &__item:nth-child(4) {
    grid-row: 3 / span 2;
  }
  &__item:nth-child(5) {
    grid-row: 5 / span 2;
  }
  &__item:nth-child(6),
  &__item:nth-child(7),
  &__item:nth-child(8),
  &__item:nth-child(9) {
    grid-column: 3 / span 6;
  }
  &__item:nth-child(6) {
    grid-row: 4;
  }
  &__item:nth-child(7) {
    grid-row: 5;
  }
  &__item:nth-child(8) {
    grid-row: 6;
  }
  &__item:nth-child(9) {
    grid-row: 7;
  }
  .card-1,
  .card-2 {
    padding-left: 4.5vw;
    padding-right: 3.5vw;
    .card__img {
      // height: 419px;
      .img{
        padding-bottom: 75%;
      }
    }
  }
  .card-4 {
    transform: translateY(-130px);
  }
  .card-5 {
    transform: translateY(50px);
  }
  .card-1,
  .card-2,
  .card-3,
  .card-4,
  .card-5 {
    .card__img {
      position: relative;
      margin-bottom: 0.6rem;
    }
    .card__category-descr {
      display: none;
    }

    .card__category-img {
      position: absolute;
      z-index: 1;
      padding: 0.2rem;
      background-color: var(--dark-bg);
    }
  }
  .card-3,
  .card-4,
  .card-5 {
    .card__img {
      // height: 226px;
      .img{
        padding-bottom: 78%;
      }
    }
  }
  .card-6,
  .card-7,
  .card-8,
  .card-9 {
    --data-offset: 35px;
    position: relative;
    padding: var(--data-offset);

    .card__title {
      --snup: 1;
      margin-top: 5px;
    }
    .card__img {
      display: none;
    }
    .data-news {
      position: absolute;
      right: var(--data-offset);
      top: calc(var(--data-offset) - 5px);
    }
  }
  .card-8,
  .card-6,
  .card-7 {
    &::before {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      height: 1px;
      width: 11vw;
      background: var(--strip);
    }
  }
  .card-6 {
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      height: 4.1vw;
      width: 1px;
      background: var(--strip);
    }
  }
  .card-9 {
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: -50%;
      height: 7.5vw;
      width: 1px;
      background: var(--strip);
    }
  }
  .card-7,
  .card-8 {
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      height: 6vw;
      width: 1px;
      background: var(--strip);
    }
  }
  .bg-dark-block {
    grid-column: 1 / span 8;
    grid-row: 4 / span 4;
    background-color: var(--dark-blog-bg);
    width: 103%;
  }
}

@media screen and (max-width: 992px) {
  .bg-dark-block {
    display: none;
  }
  .main-bar-3 {
    width: var(--main-wrapper-width);
    margin: 0 auto;
    padding: 0 0 15px;
  }
  .card {
    &__title {
      --snup: 4;
    }
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: auto;
    gap: 2.5rem 1.2rem;
    &__item:nth-child(1) {
      grid-column: 1 / span 3;
      grid-row: 1 / span 1;
    }
    &__item:nth-child(2) {
      grid-column: 4 / span 3;
      grid-row: 1 / span 1;
    }
    &__item:nth-child(3),
    &__item:nth-child(4),
    &__item:nth-child(5) {
      grid-row: 2 / span 2;
    }
    &__item:nth-child(3),
    &__item:nth-child(7) {
      grid-column: 1 / span 2;
    }
    &__item:nth-child(4),
    &__item:nth-child(8) {
      grid-column: 3 / span 2;
    }
    &__item:nth-child(5),
    &__item:nth-child(9) {
      grid-column: 5 / span 2;
    }
    &__item:nth-child(7),
    &__item:nth-child(8),
    &__item:nth-child(9) {
      grid-row: 5;
    }
    &__item:nth-child(6) {
      grid-column: 1 / span 6;
    }

    .card {
      &::after {
        content: none;
      }
      &::before {
        content: none;
      }
    }
    .card-1,
    .card-2 {
      padding: 0 0.5rem;
      .card__img {
        height: 243px;
      }
    }
    .card-3,
    .card-4,
    .card-5 {
      transform: translate(0);
      .card__img {
        height: 173px;
      }
    }
    .card-6 {
      max-width: 74%;
      text-align: center;
      padding: 0;
      margin: 0 auto;
      .card__img {
        display: block;
        height: 280px;
        position: relative;
        text-align: left;
      }
      .card__category-img {
        position: absolute;
        z-index: 1;
        background: var(--dark-bg);
      }
      .data-news {
        position: relative;
        left: 0;
        top: 0;
      }
      .card__category-descr {
        display: none;
      }
    }
    .card-7,
    .card-8,
    .card-9 {
      padding: 0;
      .card__img {
        display: block;
        height: 173px;
        position: relative;
      }
      .data-news {
        position: relative;
        left: 0;
        top: 0;
      }
      .card__title {
        --snup: 4;
      }
      .card__category-img {
        position: absolute;
        z-index: 1;
        background: var(--dark-bg);
      }

      .card__category-descr {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .main-bar-3 {
    padding: 2.5rem 0;
  }
  .card {
    &__brief {
      display: none;
    }
    &__img {
      :deep() .main-image img {
        border-radius: 4px;
        overflow: hidden;
      }
    }
    &__category-img {
      padding: 0 0.2rem;
    }
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: auto;
    gap: 1.5rem 0;
    &__item:nth-child(1),
    &__item:nth-child(2),
    &__item:nth-child(3),
    &__item:nth-child(4),
    &__item:nth-child(5),
    &__item:nth-child(6),
    &__item:nth-child(7),
    &__item:nth-child(8),
    &__item:nth-child(9) {
      grid-column: 1 / span 1;
      grid-row: auto;
    }

    .card-1,
    .card-9 {
      padding: 0 0.8rem;

      .card__img {
        height: 233px;

        :deep() .main-image img {
          border-radius: 0px;
          overflow: hidden;
        }
      }
      .card__descr {
        text-align: center;
      }
    }
    .card-2,
    .card-8 {
      padding: 0;
      display: flex;
      .card__img {
        flex: 0 0 26%;
        height: auto;
        .img {
          height: auto;
          width: 100%;
          padding-bottom: 76%;
        }
      }
      .card__category-descr {
        display: none;
      }
      .card__descr {
        display: flex;
        padding-left: 0.5rem;
        flex-direction: column;
        justify-content: center;
      }
      .card__category-img {
        position: relative;
      }
    }
    .card-3,
    .card-7 {
      padding: 0;
      display: flex;
      .card__img {
        flex: 0 0 31%;
        height: auto;
        .img {
          height: auto;
          width: 100%;
          padding-bottom: 76%;
        }
      }
      .card__category-descr {
        display: none;
      }
      .card__descr {
        display: flex;
        padding-left: 0.5rem;
        flex-direction: column;
        justify-content: center;
      }
      .card__category-img {
        position: relative;
      }
    }

    .card-4,
    .card-6 {
      padding: 0;
      display: flex;
      max-width: 100%;
      text-align: left;
      .card__img {
        flex: 0 0 35%;
        height: auto;
        overflow: hidden;
        border-radius: 4px;
        .img {
          height: auto;
          width: 100%;
          padding-bottom: 76%;
        }
      }
      .card__category-descr {
        display: none;
      }
      .card__descr {
        display: flex;
        padding-left: 0.5rem;
        flex-direction: column;
        justify-content: center;
      }
      .card__category-img {
        position: relative;
      }
      .card__title {
        --snup: 4;
      }
    }
    .card-5 {
      padding: 0;
      display: flex;
      max-width: 100%;
      text-align: left;
      .card__img {
        flex: 0 0 43%;
        height: auto;
        .img {
          height: auto;
          width: 100%;
          padding-bottom: 75%;
        }
      }
      .card__category-descr {
        display: none;
      }
      .card__descr {
        display: flex;
        padding-left: 0.5rem;
        flex-direction: column;
        justify-content: center;
      }
      .card__category-img {
        position: relative;
      }
      .card__title {
        --snup: 4;
      }
    }
  }
}
</style>
